import React, { useContext, useEffect, useRef, useState } from 'react';
import '../assets/styles/Chatbot.css';
import COUNTRYLIST from '../Country_Nationality_List.json';
import { getLocalStorage, getWithToken, patchWithToken, postWithToken, removeClassToBody } from '../API/Api';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import COMPANY_ICON from '../assets/icons/ComniqaiIcon-V3.0/company-activeicon.svg';
import SAVE_ICON from '../assets/icons/ComniqaiIcon-V3.0/save-icon.svg';
import SubContext from '../contexts/SubContext';

const ValidationErrors = {
  empty: { company: 'Company name required' },
};

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const countCharacters = (text) => {
  if (text) {
    return text.length;
  }
  return 0;
};
const maxLength = 1500;

const ChatBotProfile = () => {
  const [loader, setLoader] = useState(false);
  const subsFlag = useContext(SubContext);
  const Navigate = useNavigate();
  const { state } = useLocation();
  const [companyValues, setCompanyValues] = useState({
    company: '',
    country: '',
    city: '',
    address: '',
    phone_number: '',
    website: '',
    about_company: '',
    booking_link: '',
    support_email: '',
  });

  const [errors, setErrors] = useState({
    company: '',
  });

  const { company, country, city, phone_number, address, website, booking_link, support_email, about_company } = companyValues;

  const [apiTokenData, setApiTokenData] = useState('');
  const [botId, setBotId] = useState('');
  const [blurPopup, setBlurPopup] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
      getBotDetails(JSON.parse(token));
    } else {
      Navigate('/login');
    }
  }, []);

  const companyHandleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'about_company') {
      if (value.length >= maxLength) {
        toast.dismiss();
        toast.info('Character limit exceeded! Please keep it under 1500 characters.');
      }
    }

    setCompanyValues({ ...companyValues, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const getBotDetails = (token) => {
    setLoader(true);
    getWithToken('company/', token)
      .then((response) => {
        if (response.status === 201) {
          setBotId(response?.data?.id);
          setCompanyValues({
            ...companyValues,
            company: response?.data?.company,
            country: response?.data?.country,
            city: response?.data?.city,
            address: response?.data?.address,
            phone_number: response?.data?.phone_number,
            website: response?.data?.website,
            about_company: response?.data?.about_company,
            booking_link: response?.data?.booking_link,
            support_email: response?.data?.support_email,
          });
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const companyHandleClick = () => {
    const tempErrors = { ...errors };

    // Validate mandatory company field
    if (!companyValues.company) {
      tempErrors.company = 'Company name is required';
    } else {
      tempErrors.company = '';
    }

    if (companyValues.support_email && !isValidEmail(companyValues.support_email)) {
      tempErrors.support_email = 'Invalid email address';
    } else {
      tempErrors.support_email = '';
    }

    setErrors(tempErrors);

    if (tempErrors.company || tempErrors.support_email) {
      return false;
    }

    setLoader(true);

    if (botId) {
      patchWithToken('company/' + botId + '/', apiTokenData, companyValues)
        .then((response) => {
          if (response.status === 200) {
            getBotDetails(apiTokenData);
            toast.success(response.message);
            subsFlag.setUpdateValue('1');
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.error('error: ', error);
        })
        .finally(() => {
          setLoader(false);
        });
    } else {
      postWithToken('company/', apiTokenData, companyValues)
        .then((response) => {
          if (response.status === 201) {
            getBotDetails(apiTokenData);
            toast.success(response.message);
            subsFlag.setUpdateValue('1');
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.error('error: ', error);
        })
        .finally(() => {
          setLoader(false);
        });
    }
  };
  const onFormSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div className='comniq-container'>
        <div className='comniq-container-box mb-4'>
          <div className='d-flex align-items-center gap-3'>
            <div className='comniq-icon-box d-flex align-items-center justify-content-center'>
              <img src={COMPANY_ICON} alt='comniqai-logo' className='img-fluid' />
            </div>
            <div>
              <h5 className='mb-1 outfit-bold'>Company Information</h5>
              <p className='text-muted mb-0 outfit-regular'>Configure your company details for the chatbot</p>
            </div>
          </div>
        </div>

        {/* Company Info Form */}
        <div className='knowledge-hub'>
          <div className='card-body'>
            <form onSubmit={onFormSubmit} className='chatbox-field'>
              <div className='row mb-3'>
                <div className='col-md-6'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Company Name*</label>
                    <div className='chatbox-input-field'>
                      <input
                        type='text'
                        placeholder='Luna Compnay Ltd'
                        className='form-control chatbox-input box-shadow-hover'
                        id='company'
                        name='company'
                        value={company}
                        autoComplete='off'
                        onChange={companyHandleChange}
                      />
                      <div className='chat-error'>{errors.company && <p className='text-danger insta-smart-error'>{errors.company}</p>}</div>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Address</label>
                    <div className='chatbox-input-field'>
                      <input
                        type='text'
                        placeholder='13th Street. 47 W 13th St'
                        className='form-control chatbox-input box-shadow-hover'
                        id='address'
                        name='address'
                        value={address}
                        autoComplete='off'
                        onChange={companyHandleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='row mb-3'>
                <div className='col-md-6'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Country</label>
                    <div className='chatbox-input-field'>
                      <select className='form-control box-shadow-hover' name='country' value={country} onChange={companyHandleChange}>
                        <option selected hidden>
                          Choose the country
                        </option>
                        {COUNTRYLIST.map((row, i) => (
                          <option key={i}>{row?.en_short_name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>City</label>
                    <div className='chatbox-input-field'>
                      <input
                        type='text'
                        placeholder='New York'
                        className='form-control chatbox-input box-shadow-hover'
                        id='city'
                        name='city'
                        value={city}
                        autoComplete='off'
                        onChange={companyHandleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='row mb-3'>
                <div className='col-md-6'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Phone Number</label>
                    <div className='chatbox-input-field'>
                      <input
                        type='tel'
                        placeholder='xxxxxxxxxxx'
                        className='form-control chatbox-input box-shadow-hover'
                        id='phone_number'
                        name='phone_number'
                        value={phone_number}
                        autoComplete='off'
                        maxLength={12}
                        onChange={(e) => {
                          if (isNaN(e.target.value)) {
                            return false;
                          } else {
                            companyHandleChange(e);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Website</label>
                    <div className='chatbox-input-field'>
                      <input
                        type='text'
                        placeholder='https://comniqai.com'
                        className='form-control chatbox-input box-shadow-hover'
                        id='website'
                        name='website'
                        value={website}
                        autoComplete='off'
                        onChange={companyHandleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className='row mb-3'>
                <div className='col-md-6'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Booking Link</label>
                    <div className='chatbox-input-field'>
                      <input
                        type='text'
                        placeholder='https://comniqai.com'
                        className='form-control chatbox-input box-shadow-hover'
                        id='booking_link'
                        name='booking_link'
                        value={booking_link}
                        autoComplete='off'
                        onChange={companyHandleChange}
                      />
                    </div>
                  </div>
                  <small className='text-muted'>Add a link to your booking or scheduling system (e.g. Calendly, Booking.com, etc.)</small>
                </div>
                <div className='col-md-6'>
                  <div className='chatbox-input-text input-GPT new'>
                    <label className='outfit-medium'>Support Email</label>
                    <div className='chatbox-input-field'>
                      <input
                        type='text'
                        placeholder='Enter your support email'
                        className='form-control chatbox-input box-shadow-hover'
                        id='support_email'
                        name='support_email'
                        value={support_email}
                        autoComplete='off'
                        onChange={companyHandleChange}
                      />
                      <div className='chat-error'>{errors?.support_email && <p className='text-danger insta-smart-error'>{errors?.support_email}</p>}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='mb-4'>
                <div className='chatbox-input-text input-GPT new'>
                  <div className='d-flex justify-content-between align-items-center'>
                    <label className='mb-1 outfit-medium'>About Company</label>
                    <p className='mb-0 outfit-regular font14 text-end'>({countCharacters(about_company) || 0} / 1500)</p>
                  </div>
                  <div className='chatbox-input-field'>
                    <textarea
                      rows='10'
                      className='form-control chatbox-input textarea-height box-shadow-hover'
                      placeholder='Describe about your company '
                      id='about_company'
                      name='about_company'
                      value={about_company}
                      autoComplete='off'
                      onChange={companyHandleChange}
                      maxLength={1500}
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-wrap align-items-center justify-content-between'>
                <button type='submit' className='chatbot-save-btn d-flex align-items-center gap-2' id='firstButton' onClick={companyHandleClick}>
                  <img src={SAVE_ICON} alt='save-icon' /> Save Changes
                </button>
                {state != null && state?.faqFlag && (
                  <button
                    className='btn btn-submit-login bg-themeLightGreenGradient'
                    onClick={() => Navigate('/chatbot/knowledgebase', { state: { faqFlag: true, id: state?.id, length: state?.length } })}
                  >
                    Continue
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {loader && (
        <div className='loader-center'>
          <Loader />
        </div>
      )}

      {blurPopup && (
        <div className='custom-popup'>
          <div className='popup-content'>
            <div className={'popup-head text-center'}>
              <h4>Train Agent Again</h4>
            </div>
            <hr />
            <div className='popup-footer text-center'>
              <button className='btn danger-btn mx-1 text-capitalize' data-dismiss='modal' onClick={() => setBlurPopup(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatBotProfile;
